// GENERATED by `__sync-pinyin-audio.ts` — do not edit.
// The pinyin syllable keys with bundled audio, mirrored into `public/pinyin-audio/`.
export const PINYIN_SYLLABLE_KEYS: readonly string[] = [
  "1000",
  "a",
  "a1",
  "a2",
  "a3",
  "a4",
  "ai",
  "ai1",
  "ai2",
  "ai3",
  "ai4",
  "an",
  "an1",
  "an2",
  "an3",
  "an4",
  "ang",
  "ang1",
  "ang2",
  "ang3",
  "ang4",
  "ao",
  "ao1",
  "ao2",
  "ao3",
  "ao4",
  "ba",
  "ba1",
  "ba2",
  "ba3",
  "ba4",
  "bai",
  "bai1",
  "bai2",
  "bai2-old1",
  "bai3",
  "bai4",
  "ban",
  "ban1",
  "ban2",
  "ban3",
  "ban4",
  "bang",
  "bang1",
  "bang2",
  "bang3",
  "bang4",
  "bao",
  "bao1",
  "bao1-old1",
  "bao2",
  "bao3",
  "bao4",
  "bei",
  "bei1",
  "bei2",
  "bei3",
  "bei4",
  "ben",
  "ben1",
  "ben2",
  "ben3",
  "ben4",
  "beng",
  "beng1",
  "beng2",
  "beng3",
  "beng4",
  "bi",
  "bi1",
  "bi2",
  "bi3",
  "bi4",
  "bian",
  "bian1",
  "bian1-old1",
  "bian2",
  "bian3",
  "bian4",
  "biao",
  "biao1",
  "biao2",
  "biao3",
  "biao4",
  "bie",
  "bie1",
  "bie2",
  "bie3",
  "bie4",
  "bin",
  "bin1",
  "bin2",
  "bin3",
  "bin4",
  "bing",
  "bing1",
  "bing2",
  "bing3",
  "bing4",
  "bo",
  "bo1",
  "bo2",
  "bo3",
  "bo4",
  "bu",
  "bu1",
  "bu2",
  "bu3",
  "bu4",
  "ca",
  "ca1",
  "ca2",
  "ca3",
  "ca4",
  "cai",
  "cai1",
  "cai2",
  "cai3",
  "cai4",
  "can",
  "can1",
  "can2",
  "can3",
  "can4",
  "cang",
  "cang1",
  "cang2",
  "cang3",
  "cang4",
  "cao",
  "cao1",
  "cao2",
  "cao3",
  "cao4",
  "ce",
  "ce1",
  "ce2",
  "ce3",
  "ce4",
  "cen",
  "cen1",
  "cen2",
  "cen3",
  "cen4",
  "ceng",
  "ceng1",
  "ceng2",
  "ceng3",
  "ceng4",
  "cha",
  "cha1",
  "cha2",
  "cha3",
  "cha4",
  "chai",
  "chai1",
  "chai2",
  "chai3",
  "chai4",
  "chan",
  "chan1",
  "chan2",
  "chan3",
  "chan4",
  "chang",
  "chang1",
  "chang2",
  "chang3",
  "chang4",
  "chao",
  "chao1",
  "chao2",
  "chao3",
  "chao4",
  "che",
  "che1",
  "che2",
  "che3",
  "che4",
  "chen",
  "chen1",
  "chen2",
  "chen3",
  "chen4",
  "cheng",
  "cheng1",
  "cheng2",
  "cheng3",
  "cheng4",
  "chi",
  "chi1",
  "chi2",
  "chi3",
  "chi4",
  "chong",
  "chong1",
  "chong2",
  "chong3",
  "chong4",
  "chou",
  "chou1",
  "chou2",
  "chou3",
  "chou4",
  "chu",
  "chu1",
  "chu2",
  "chu3",
  "chu4",
  "chua",
  "chua1",
  "chua2",
  "chua3",
  "chua4",
  "chuai",
  "chuai1",
  "chuai2",
  "chuai3",
  "chuai4",
  "chuan",
  "chuan1",
  "chuan2",
  "chuan3",
  "chuan4",
  "chuang",
  "chuang1",
  "chuang2",
  "chuang3",
  "chuang4",
  "chui",
  "chui1",
  "chui2",
  "chui3",
  "chui4",
  "chun",
  "chun1",
  "chun2",
  "chun3",
  "chun4",
  "chuo",
  "chuo1",
  "chuo2",
  "chuo3",
  "chuo4",
  "ci",
  "ci1",
  "ci2",
  "ci3",
  "ci4",
  "cong",
  "cong1",
  "cong2",
  "cong3",
  "cong4",
  "cou",
  "cou1",
  "cou2",
  "cou3",
  "cou4",
  "cu",
  "cu1",
  "cu2",
  "cu3",
  "cu4",
  "cuan",
  "cuan1",
  "cuan2",
  "cuan3",
  "cuan4",
  "cui",
  "cui1",
  "cui2",
  "cui3",
  "cui4",
  "cun",
  "cun1",
  "cun2",
  "cun3",
  "cun4",
  "cuo",
  "cuo1",
  "cuo2",
  "cuo3",
  "cuo4",
  "da",
  "da1",
  "da2",
  "da3",
  "da4",
  "dai",
  "dai1",
  "dai2",
  "dai3",
  "dai4",
  "dan",
  "dan1",
  "dan2",
  "dan3",
  "dan4",
  "dang",
  "dang1",
  "dang2",
  "dang3",
  "dang4",
  "dao",
  "dao1",
  "dao2",
  "dao3",
  "dao4",
  "de",
  "de1",
  "de2",
  "de3",
  "de4",
  "den",
  "den1",
  "den2",
  "den3",
  "den4",
  "deng",
  "deng1",
  "deng2",
  "deng3",
  "deng4",
  "di",
  "di1",
  "di2",
  "di3",
  "di4",
  "dian",
  "dian1",
  "dian2",
  "dian3",
  "dian4",
  "diao",
  "diao1",
  "diao2",
  "diao3",
  "diao4",
  "die",
  "die1",
  "die2",
  "die3",
  "die4",
  "ding",
  "ding1",
  "ding2",
  "ding3",
  "ding4",
  "diu",
  "diu1",
  "diu2",
  "diu3",
  "diu4",
  "dong",
  "dong1",
  "dong2",
  "dong3",
  "dong4",
  "dou",
  "dou1",
  "dou2",
  "dou3",
  "dou4",
  "du",
  "du1",
  "du2",
  "du3",
  "du4",
  "duan",
  "duan1",
  "duan2",
  "duan3",
  "duan4",
  "dui",
  "dui1",
  "dui2",
  "dui3",
  "dui4",
  "dun",
  "dun1",
  "dun2",
  "dun3",
  "dun4",
  "duo",
  "duo1",
  "duo2",
  "duo3",
  "duo4",
  "e",
  "e1",
  "e2",
  "e3",
  "e4",
  "ei",
  "ei1",
  "ei2",
  "ei3",
  "ei4",
  "en",
  "en1",
  "en2",
  "en3",
  "en4",
  "eng",
  "eng1",
  "eng2",
  "eng3",
  "eng4",
  "er",
  "er1",
  "er2",
  "er3",
  "er4",
  "fa",
  "fa1",
  "fa1-old1",
  "fa2",
  "fa3",
  "fa4",
  "fan",
  "fan1",
  "fan2",
  "fan3",
  "fan4",
  "fang",
  "fang1",
  "fang2",
  "fang3",
  "fang4",
  "fei",
  "fei1",
  "fei2",
  "fei3",
  "fei4",
  "fen",
  "fen1",
  "fen2",
  "fen3",
  "fen4",
  "feng",
  "feng1",
  "feng2",
  "feng3",
  "feng4",
  "fiao",
  "fiao1",
  "fiao2",
  "fiao3",
  "fiao4",
  "fo",
  "fo1",
  "fo2",
  "fo3",
  "fo4",
  "fou",
  "fou1",
  "fou2",
  "fou3",
  "fou4",
  "fu",
  "fu1",
  "fu2",
  "fu3",
  "fu4",
  "ga",
  "ga1",
  "ga2",
  "ga3",
  "ga4",
  "gai",
  "gai1",
  "gai2",
  "gai3",
  "gai4",
  "gan",
  "gan1",
  "gan2",
  "gan3",
  "gan4",
  "gang",
  "gang1",
  "gang2",
  "gang3",
  "gang4",
  "gao",
  "gao1",
  "gao2",
  "gao3",
  "gao4",
  "ge",
  "ge1",
  "ge2",
  "ge3",
  "ge4",
  "gei",
  "gei1",
  "gei2",
  "gei3",
  "gei4",
  "gen",
  "gen1",
  "gen2",
  "gen3",
  "gen4",
  "geng",
  "geng1",
  "geng2",
  "geng3",
  "geng4",
  "gong",
  "gong1",
  "gong2",
  "gong3",
  "gong4",
  "gou",
  "gou1",
  "gou2",
  "gou3",
  "gou4",
  "gu",
  "gu1",
  "gu2",
  "gu3",
  "gu4",
  "gua",
  "gua1",
  "gua2",
  "gua3",
  "gua4",
  "guai",
  "guai1",
  "guai2",
  "guai3",
  "guai4",
  "guan",
  "guan1",
  "guan2",
  "guan3",
  "guan4",
  "guang",
  "guang1",
  "guang2",
  "guang3",
  "guang4",
  "gui",
  "gui1",
  "gui2",
  "gui3",
  "gui4",
  "gun",
  "gun1",
  "gun2",
  "gun3",
  "gun4",
  "guo",
  "guo1",
  "guo2",
  "guo3",
  "guo4",
  "ha",
  "ha1",
  "ha2",
  "ha3",
  "ha4",
  "hai",
  "hai1",
  "hai2",
  "hai3",
  "hai4",
  "han",
  "han1",
  "han2",
  "han3",
  "han4",
  "hang",
  "hang1",
  "hang2",
  "hang3",
  "hang4",
  "hao",
  "hao1",
  "hao2",
  "hao3",
  "hao4",
  "he",
  "he1",
  "he2",
  "he3",
  "he4",
  "hei",
  "hei1",
  "hei2",
  "hei3",
  "hei4",
  "hen",
  "hen1",
  "hen2",
  "hen3",
  "hen4",
  "heng",
  "heng1",
  "heng2",
  "heng3",
  "heng4",
  "hm",
  "hm1",
  "hm2",
  "hm3",
  "hm4",
  "hong",
  "hong1",
  "hong2",
  "hong3",
  "hong4",
  "hou",
  "hou1",
  "hou2",
  "hou3",
  "hou4",
  "hu",
  "hu1",
  "hu2",
  "hu3",
  "hu4",
  "hua",
  "hua1",
  "hua2",
  "hua3",
  "hua4",
  "huai",
  "huai1",
  "huai2",
  "huai3",
  "huai4",
  "huan",
  "huan1",
  "huan2",
  "huan3",
  "huan4",
  "huang",
  "huang1",
  "huang2",
  "huang3",
  "huang4",
  "hui",
  "hui1",
  "hui2",
  "hui3",
  "hui4",
  "hun",
  "hun1",
  "hun2",
  "hun3",
  "hun4",
  "huo",
  "huo1",
  "huo2",
  "huo3",
  "huo4",
  "ji",
  "ji1",
  "ji2",
  "ji3",
  "ji4",
  "jia",
  "jia1",
  "jia2",
  "jia3",
  "jia4",
  "jian",
  "jian1",
  "jian2",
  "jian3",
  "jian4",
  "jiang",
  "jiang1",
  "jiang2",
  "jiang3",
  "jiang4",
  "jiao",
  "jiao1",
  "jiao2",
  "jiao3",
  "jiao4",
  "jie",
  "jie1",
  "jie2",
  "jie3",
  "jie4",
  "jin",
  "jin1",
  "jin2",
  "jin3",
  "jin4",
  "jing",
  "jing1",
  "jing2",
  "jing3",
  "jing4",
  "jiong",
  "jiong1",
  "jiong2",
  "jiong3",
  "jiong4",
  "jiu",
  "jiu1",
  "jiu2",
  "jiu3",
  "jiu4",
  "ju",
  "ju1",
  "ju2",
  "ju3",
  "ju4",
  "juan",
  "juan1",
  "juan2",
  "juan3",
  "juan4",
  "jue",
  "jue1",
  "jue2",
  "jue3",
  "jue4",
  "jun",
  "jun1",
  "jun2",
  "jun3",
  "jun4",
  "ka",
  "ka1",
  "ka2",
  "ka3",
  "ka4",
  "kai",
  "kai1",
  "kai2",
  "kai3",
  "kai4",
  "kan",
  "kan1",
  "kan2",
  "kan3",
  "kan4",
  "kang",
  "kang1",
  "kang2",
  "kang3",
  "kang4",
  "kao",
  "kao1",
  "kao2",
  "kao3",
  "kao4",
  "ke",
  "ke1",
  "ke2",
  "ke3",
  "ke4",
  "ken",
  "ken1",
  "ken2",
  "ken3",
  "ken4",
  "keng",
  "keng1",
  "keng2",
  "keng3",
  "keng4",
  "kong",
  "kong1",
  "kong2",
  "kong3",
  "kong4",
  "kou",
  "kou1",
  "kou2",
  "kou3",
  "kou4",
  "ku",
  "ku1",
  "ku2",
  "ku3",
  "ku4",
  "kua",
  "kua1",
  "kua2",
  "kua3",
  "kua4",
  "kuai",
  "kuai1",
  "kuai2",
  "kuai3",
  "kuai4",
  "kuan",
  "kuan1",
  "kuan2",
  "kuan3",
  "kuan4",
  "kuang",
  "kuang1",
  "kuang2",
  "kuang3",
  "kuang4",
  "kui",
  "kui1",
  "kui2",
  "kui3",
  "kui4",
  "kun",
  "kun1",
  "kun2",
  "kun3",
  "kun4",
  "kuo",
  "kuo1",
  "kuo2",
  "kuo3",
  "kuo4",
  "la",
  "la1",
  "la2",
  "la3",
  "la4",
  "lai",
  "lai1",
  "lai2",
  "lai3",
  "lai4",
  "lan",
  "lan1",
  "lan2",
  "lan3",
  "lan4",
  "lang",
  "lang1",
  "lang2",
  "lang3",
  "lang4",
  "lao",
  "lao1",
  "lao2",
  "lao3",
  "lao4",
  "le",
  "le1",
  "le2",
  "le3",
  "le4",
  "lei",
  "lei1",
  "lei2",
  "lei3",
  "lei4",
  "leng",
  "leng1",
  "leng2",
  "leng3",
  "leng4",
  "li",
  "li1",
  "li2",
  "li3",
  "li4",
  "lia",
  "lia1",
  "lia2",
  "lia3",
  "lia4",
  "lian",
  "lian1",
  "lian2",
  "lian3",
  "lian4",
  "liang",
  "liang1",
  "liang2",
  "liang3",
  "liang4",
  "liao",
  "liao1",
  "liao2",
  "liao3",
  "liao4",
  "lie",
  "lie1",
  "lie2",
  "lie3",
  "lie4",
  "lin",
  "lin1",
  "lin2",
  "lin3",
  "lin4",
  "ling",
  "ling1",
  "ling2",
  "ling3",
  "ling4",
  "liu",
  "liu1",
  "liu2",
  "liu3",
  "liu4",
  "lo",
  "lo1",
  "lo2",
  "lo3",
  "lo4",
  "long",
  "long1",
  "long2",
  "long3",
  "long4",
  "lou",
  "lou1",
  "lou2",
  "lou3",
  "lou4",
  "lu",
  "lu1",
  "lu2",
  "lu3",
  "lu4",
  "luan",
  "luan1",
  "luan2",
  "luan3",
  "luan4",
  "lun",
  "lun1",
  "lun2",
  "lun3",
  "lun4",
  "luo",
  "luo1",
  "luo2",
  "luo3",
  "luo4",
  "lv",
  "lv1",
  "lv2",
  "lv3",
  "lv4",
  "lve",
  "lve1",
  "lve2",
  "lve3",
  "lve4",
  "m",
  "m1",
  "m2",
  "m3",
  "m4",
  "ma",
  "ma1",
  "ma2",
  "ma3",
  "ma4",
  "mai",
  "mai1",
  "mai2",
  "mai3",
  "mai4",
  "man",
  "man1",
  "man2",
  "man3",
  "man4",
  "mang",
  "mang1",
  "mang2",
  "mang3",
  "mang4",
  "mao",
  "mao1",
  "mao2",
  "mao3",
  "mao4",
  "me",
  "me1",
  "me2",
  "me3",
  "me4",
  "mei",
  "mei1",
  "mei2",
  "mei3",
  "mei4",
  "men",
  "men1",
  "men2",
  "men3",
  "men4",
  "meng",
  "meng1",
  "meng2",
  "meng3",
  "meng4",
  "mi",
  "mi1",
  "mi2",
  "mi3",
  "mi4",
  "mian",
  "mian1",
  "mian2",
  "mian3",
  "mian4",
  "mian4-old1",
  "miao",
  "miao1",
  "miao2",
  "miao3",
  "miao4",
  "mie",
  "mie1",
  "mie2",
  "mie3",
  "mie4",
  "min",
  "min1",
  "min2",
  "min3",
  "min4",
  "ming",
  "ming1",
  "ming2",
  "ming3",
  "ming4",
  "miu",
  "miu1",
  "miu2",
  "miu3",
  "miu4",
  "mo",
  "mo1",
  "mo2",
  "mo3",
  "mo4",
  "mou",
  "mou1",
  "mou2",
  "mou3",
  "mou4",
  "mu",
  "mu1",
  "mu2",
  "mu3",
  "mu4",
  "n",
  "n1",
  "n2",
  "n3",
  "n4",
  "na",
  "na1",
  "na2",
  "na3",
  "na4",
  "nai",
  "nai1",
  "nai2",
  "nai3",
  "nai4",
  "nan",
  "nan1",
  "nan2",
  "nan3",
  "nan4",
  "nang",
  "nang1",
  "nang2",
  "nang3",
  "nang4",
  "nao",
  "nao1",
  "nao2",
  "nao3",
  "nao4",
  "ne",
  "ne1",
  "ne2",
  "ne3",
  "ne4",
  "nei",
  "nei1",
  "nei2",
  "nei3",
  "nei4",
  "nen",
  "nen1",
  "nen2",
  "nen3",
  "nen4",
  "neng",
  "neng1",
  "neng2",
  "neng3",
  "neng4",
  "ni",
  "ni1",
  "ni2",
  "ni3",
  "ni4",
  "nian",
  "nian1",
  "nian2",
  "nian3",
  "nian4",
  "niang",
  "niang1",
  "niang2",
  "niang3",
  "niang4",
  "niao",
  "niao1",
  "niao2",
  "niao3",
  "niao4",
  "nie",
  "nie1",
  "nie2",
  "nie3",
  "nie4",
  "nin",
  "nin1",
  "nin2",
  "nin3",
  "nin4",
  "ning",
  "ning1",
  "ning2",
  "ning3",
  "ning4",
  "niu",
  "niu1",
  "niu2",
  "niu3",
  "niu4",
  "nong",
  "nong1",
  "nong2",
  "nong3",
  "nong4",
  "nou",
  "nou1",
  "nou2",
  "nou3",
  "nou4",
  "nu",
  "nu1",
  "nu2",
  "nu3",
  "nu4",
  "nuan",
  "nuan1",
  "nuan2",
  "nuan3",
  "nuan4",
  "nun",
  "nun1",
  "nun2",
  "nun3",
  "nun4",
  "nuo",
  "nuo1",
  "nuo2",
  "nuo3",
  "nuo4",
  "nv",
  "nv1",
  "nv2",
  "nv3",
  "nv4",
  "nve",
  "nve1",
  "nve2",
  "nve3",
  "nve4",
  "o",
  "o1",
  "o2",
  "o3",
  "o4",
  "ou",
  "ou1",
  "ou2",
  "ou3",
  "ou4",
  "pa",
  "pa1",
  "pa2",
  "pa3",
  "pa4",
  "pai",
  "pai1",
  "pai2",
  "pai3",
  "pai4",
  "pan",
  "pan1",
  "pan2",
  "pan3",
  "pan4",
  "pang",
  "pang1",
  "pang2",
  "pang3",
  "pang4",
  "pao",
  "pao1",
  "pao2",
  "pao3",
  "pao4",
  "pei",
  "pei1",
  "pei2",
  "pei3",
  "pei4",
  "pen",
  "pen1",
  "pen2",
  "pen3",
  "pen4",
  "peng",
  "peng1",
  "peng2",
  "peng3",
  "peng4",
  "pi",
  "pi1",
  "pi2",
  "pi3",
  "pi4",
  "pian",
  "pian1",
  "pian2",
  "pian3",
  "pian4",
  "piao",
  "piao1",
  "piao2",
  "piao3",
  "piao4",
  "pie",
  "pie1",
  "pie2",
  "pie3",
  "pie4",
  "pin",
  "pin1",
  "pin2",
  "pin3",
  "pin4",
  "ping",
  "ping1",
  "ping2",
  "ping3",
  "ping4",
  "po",
  "po1",
  "po2",
  "po3",
  "po4",
  "pou",
  "pou1",
  "pou2",
  "pou3",
  "pou4",
  "pu",
  "pu1",
  "pu2",
  "pu3",
  "pu4",
  "qi",
  "qi1",
  "qi2",
  "qi3",
  "qi4",
  "qia",
  "qia1",
  "qia2",
  "qia3",
  "qia4",
  "qian",
  "qian1",
  "qian2",
  "qian3",
  "qian4",
  "qiang",
  "qiang1",
  "qiang2",
  "qiang3",
  "qiang4",
  "qiao",
  "qiao1",
  "qiao2",
  "qiao3",
  "qiao4",
  "qie",
  "qie1",
  "qie2",
  "qie3",
  "qie4",
  "qin",
  "qin1",
  "qin2",
  "qin3",
  "qin4",
  "qing",
  "qing1",
  "qing2",
  "qing3",
  "qing4",
  "qiong",
  "qiong1",
  "qiong2",
  "qiong3",
  "qiong4",
  "qiu",
  "qiu1",
  "qiu2",
  "qiu3",
  "qiu4",
  "qu",
  "qu1",
  "qu2",
  "qu3",
  "qu4",
  "quan",
  "quan1",
  "quan2",
  "quan3",
  "quan4",
  "que",
  "que1",
  "que2",
  "que3",
  "que4",
  "qun",
  "qun1",
  "qun2",
  "qun3",
  "qun4",
  "ran",
  "ran1",
  "ran2",
  "ran3",
  "ran4",
  "rang",
  "rang1",
  "rang2",
  "rang3",
  "rang4",
  "rao",
  "rao1",
  "rao2",
  "rao3",
  "rao4",
  "re",
  "re1",
  "re2",
  "re3",
  "re4",
  "ren",
  "ren1",
  "ren2",
  "ren3",
  "ren4",
  "reng",
  "reng1",
  "reng2",
  "reng3",
  "reng4",
  "ri",
  "ri1",
  "ri2",
  "ri3",
  "ri4",
  "rong",
  "rong1",
  "rong2",
  "rong3",
  "rong4",
  "rou",
  "rou1",
  "rou2",
  "rou3",
  "rou4",
  "ru",
  "ru1",
  "ru2",
  "ru3",
  "ru4",
  "rua",
  "rua1",
  "rua2",
  "rua3",
  "rua4",
  "ruan",
  "ruan1",
  "ruan2",
  "ruan3",
  "ruan4",
  "rui",
  "rui1",
  "rui2",
  "rui3",
  "rui4",
  "run",
  "run1",
  "run2",
  "run3",
  "run4",
  "ruo",
  "ruo1",
  "ruo2",
  "ruo3",
  "ruo4",
  "sa",
  "sa1",
  "sa2",
  "sa3",
  "sa4",
  "sai",
  "sai1",
  "sai2",
  "sai3",
  "sai4",
  "san",
  "san1",
  "san2",
  "san3",
  "san4",
  "sang",
  "sang1",
  "sang2",
  "sang3",
  "sang4",
  "sao",
  "sao1",
  "sao2",
  "sao3",
  "sao4",
  "se",
  "se1",
  "se2",
  "se3",
  "se4",
  "sen",
  "sen1",
  "sen2",
  "sen3",
  "sen4",
  "seng",
  "seng1",
  "seng2",
  "seng3",
  "seng4",
  "sha",
  "sha1",
  "sha2",
  "sha3",
  "sha4",
  "shai",
  "shai1",
  "shai2",
  "shai3",
  "shai4",
  "shan",
  "shan1",
  "shan2",
  "shan3",
  "shan4",
  "shang",
  "shang1",
  "shang2",
  "shang3",
  "shang4",
  "shao",
  "shao1",
  "shao2",
  "shao3",
  "shao4",
  "she",
  "she1",
  "she2",
  "she3",
  "she4",
  "shei",
  "shei1",
  "shei2",
  "shei3",
  "shei4",
  "shen",
  "shen1",
  "shen2",
  "shen3",
  "shen4",
  "sheng",
  "sheng1",
  "sheng2",
  "sheng3",
  "sheng4",
  "shi",
  "shi1",
  "shi2",
  "shi3",
  "shi4",
  "shou",
  "shou1",
  "shou2",
  "shou3",
  "shou4",
  "shu",
  "shu1",
  "shu2",
  "shu3",
  "shu4",
  "shua",
  "shua1",
  "shua2",
  "shua3",
  "shua4",
  "shuai",
  "shuai1",
  "shuai2",
  "shuai3",
  "shuai4",
  "shuan",
  "shuan1",
  "shuan2",
  "shuan3",
  "shuan4",
  "shuang",
  "shuang1",
  "shuang2",
  "shuang3",
  "shuang4",
  "shui",
  "shui1",
  "shui2",
  "shui3",
  "shui4",
  "shun",
  "shun1",
  "shun2",
  "shun3",
  "shun4",
  "shuo",
  "shuo1",
  "shuo2",
  "shuo3",
  "shuo4",
  "si",
  "si1",
  "si2",
  "si3",
  "si4",
  "song",
  "song1",
  "song2",
  "song3",
  "song4",
  "sou",
  "sou1",
  "sou2",
  "sou3",
  "sou4",
  "su",
  "su1",
  "su2",
  "su3",
  "su4",
  "suan",
  "suan1",
  "suan2",
  "suan3",
  "suan4",
  "sui",
  "sui1",
  "sui2",
  "sui3",
  "sui4",
  "sun",
  "sun1",
  "sun2",
  "sun3",
  "sun4",
  "suo",
  "suo1",
  "suo2",
  "suo3",
  "suo4",
  "ta",
  "ta1",
  "ta2",
  "ta3",
  "ta4",
  "tai",
  "tai1",
  "tai2",
  "tai3",
  "tai4",
  "tan",
  "tan1",
  "tan2",
  "tan3",
  "tan4",
  "tang",
  "tang1",
  "tang2",
  "tang3",
  "tang4",
  "tao",
  "tao1",
  "tao2",
  "tao3",
  "tao4",
  "te",
  "te1",
  "te2",
  "te3",
  "te4",
  "teng",
  "teng1",
  "teng2",
  "teng3",
  "teng4",
  "ti",
  "ti1",
  "ti2",
  "ti3",
  "ti4",
  "tian",
  "tian1",
  "tian2",
  "tian3",
  "tian4",
  "tiao",
  "tiao1",
  "tiao2",
  "tiao3",
  "tiao4",
  "tie",
  "tie1",
  "tie2",
  "tie3",
  "tie4",
  "ting",
  "ting1",
  "ting2",
  "ting3",
  "ting4",
  "tong",
  "tong1",
  "tong2",
  "tong3",
  "tong4",
  "tou",
  "tou1",
  "tou2",
  "tou3",
  "tou4",
  "tu",
  "tu1",
  "tu2",
  "tu3",
  "tu4",
  "tuan",
  "tuan1",
  "tuan2",
  "tuan3",
  "tuan4",
  "tui",
  "tui1",
  "tui2",
  "tui3",
  "tui4",
  "tun",
  "tun1",
  "tun2",
  "tun3",
  "tun4",
  "tuo",
  "tuo1",
  "tuo2",
  "tuo3",
  "tuo4",
  "wa",
  "wa1",
  "wa2",
  "wa3",
  "wa4",
  "wai",
  "wai1",
  "wai2",
  "wai3",
  "wai4",
  "wan",
  "wan1",
  "wan2",
  "wan3",
  "wan4",
  "wang",
  "wang1",
  "wang2",
  "wang3",
  "wang4",
  "wei",
  "wei1",
  "wei2",
  "wei3",
  "wei4",
  "wen",
  "wen1",
  "wen2",
  "wen3",
  "wen4",
  "weng",
  "weng1",
  "weng2",
  "weng3",
  "weng4",
  "wo",
  "wo1",
  "wo2",
  "wo3",
  "wo4",
  "wu",
  "wu1",
  "wu2",
  "wu3",
  "wu4",
  "xi",
  "xi1",
  "xi1-old1",
  "xi2",
  "xi3",
  "xi4",
  "xia",
  "xia1",
  "xia2",
  "xia3",
  "xia4",
  "xian",
  "xian1",
  "xian2",
  "xian3",
  "xian4",
  "xiang",
  "xiang1",
  "xiang2",
  "xiang3",
  "xiang4",
  "xiao",
  "xiao1",
  "xiao2",
  "xiao3",
  "xiao4",
  "xie",
  "xie1",
  "xie2",
  "xie3",
  "xie4",
  "xin",
  "xin1",
  "xin2",
  "xin3",
  "xin4",
  "xing",
  "xing1",
  "xing2",
  "xing3",
  "xing4",
  "xiong",
  "xiong1",
  "xiong2",
  "xiong3",
  "xiong4",
  "xiu",
  "xiu1",
  "xiu2",
  "xiu3",
  "xiu4",
  "xu",
  "xu1",
  "xu2",
  "xu3",
  "xu4",
  "xuan",
  "xuan1",
  "xuan2",
  "xuan3",
  "xuan4",
  "xue",
  "xue1",
  "xue2",
  "xue3",
  "xue4",
  "xun",
  "xun1",
  "xun2",
  "xun3",
  "xun4",
  "ya",
  "ya1",
  "ya2",
  "ya3",
  "ya4",
  "yan",
  "yan1",
  "yan2",
  "yan3",
  "yan4",
  "yang",
  "yang1",
  "yang2",
  "yang3",
  "yang4",
  "yao",
  "yao1",
  "yao2",
  "yao3",
  "yao4",
  "ye",
  "ye1",
  "ye2",
  "ye3",
  "ye4",
  "yi",
  "yi1",
  "yi2",
  "yi3",
  "yi4",
  "yin",
  "yin1",
  "yin2",
  "yin3",
  "yin4",
  "ying",
  "ying1",
  "ying2",
  "ying3",
  "ying4",
  "yo",
  "yo1",
  "yo2",
  "yo3",
  "yo4",
  "yong",
  "yong1",
  "yong2",
  "yong3",
  "yong4",
  "you",
  "you1",
  "you2",
  "you3",
  "you4",
  "yu",
  "yu1",
  "yu2",
  "yu3",
  "yu4",
  "yuan",
  "yuan1",
  "yuan2",
  "yuan3",
  "yuan4",
  "yue",
  "yue1",
  "yue2",
  "yue3",
  "yue4",
  "yun",
  "yun1",
  "yun2",
  "yun3",
  "yun4",
  "za",
  "za1",
  "za2",
  "za3",
  "za4",
  "zai",
  "zai1",
  "zai2",
  "zai3",
  "zai4",
  "zan",
  "zan1",
  "zan2",
  "zan3",
  "zan4",
  "zang",
  "zang1",
  "zang2",
  "zang3",
  "zang4",
  "zao",
  "zao1",
  "zao2",
  "zao3",
  "zao4",
  "ze",
  "ze1",
  "ze2",
  "ze3",
  "ze4",
  "zei",
  "zei1",
  "zei2",
  "zei3",
  "zei4",
  "zen",
  "zen1",
  "zen2",
  "zen3",
  "zen4",
  "zeng",
  "zeng1",
  "zeng2",
  "zeng3",
  "zeng4",
  "zha",
  "zha1",
  "zha2",
  "zha3",
  "zha4",
  "zhai",
  "zhai1",
  "zhai2",
  "zhai3",
  "zhai4",
  "zhan",
  "zhan1",
  "zhan2",
  "zhan3",
  "zhan4",
  "zhang",
  "zhang1",
  "zhang2",
  "zhang3",
  "zhang4",
  "zhao",
  "zhao1",
  "zhao2",
  "zhao3",
  "zhao4",
  "zhe",
  "zhe1",
  "zhe2",
  "zhe3",
  "zhe4",
  "zhei4",
  "zhen",
  "zhen1",
  "zhen2",
  "zhen3",
  "zhen4",
  "zheng",
  "zheng1",
  "zheng2",
  "zheng3",
  "zheng4",
  "zhi",
  "zhi1",
  "zhi2",
  "zhi3",
  "zhi4",
  "zhong",
  "zhong1",
  "zhong2",
  "zhong3",
  "zhong4",
  "zhou",
  "zhou1",
  "zhou2",
  "zhou3",
  "zhou4",
  "zhu",
  "zhu1",
  "zhu2",
  "zhu3",
  "zhu4",
  "zhua",
  "zhua1",
  "zhua2",
  "zhua3",
  "zhua4",
  "zhuai",
  "zhuai1",
  "zhuai2",
  "zhuai3",
  "zhuai4",
  "zhuan",
  "zhuan1",
  "zhuan2",
  "zhuan3",
  "zhuan4",
  "zhuang",
  "zhuang1",
  "zhuang2",
  "zhuang3",
  "zhuang4",
  "zhui",
  "zhui1",
  "zhui2",
  "zhui3",
  "zhui4",
  "zhun",
  "zhun1",
  "zhun2",
  "zhun3",
  "zhun4",
  "zhuo",
  "zhuo1",
  "zhuo2",
  "zhuo3",
  "zhuo4",
  "zi",
  "zi1",
  "zi2",
  "zi3",
  "zi4",
  "zong",
  "zong1",
  "zong2",
  "zong3",
  "zong4",
  "zou",
  "zou1",
  "zou2",
  "zou3",
  "zou4",
  "zu",
  "zu1",
  "zu2",
  "zu3",
  "zu4",
  "zuan",
  "zuan1",
  "zuan2",
  "zuan3",
  "zuan4",
  "zui",
  "zui1",
  "zui2",
  "zui3",
  "zui4",
  "zun",
  "zun1",
  "zun2",
  "zun3",
  "zun4",
  "zuo",
  "zuo1",
  "zuo2",
  "zuo3",
  "zuo4"
];
